<div class="main-container">
  @if (loading) {
    <app-loading-element
      class="container-fluido componentBelow"
    ></app-loading-element>
  }
  <app-system-message></app-system-message>
  @if (loading) {
    <app-loading-element></app-loading-element>
  }
  <!-- Sub-group create view -->
  @if (this.tab === 'create') {
    <section
      [ngClass]="theme.getThemeClass()"
      class="card"
    >
    <article>
      <h4 class="card-title mt-0 text-center">
        {{ "newSubGroup" | translate }}
      </h4>
      <form class="form-container">
        <div [ngClass]="theme.getThemeClass()" class="form-header">
          <div class="input-button-row" style="display: flex">
            <!-- Label above input -->
            <label class="label-spacer" for="sub-group-name">
              {{ "subGroupCreateGroupName" | translate }}
              <span class="requiredStar">*</span>
            </label>
            <!-- Input group -->
            &NonBreakingSpace;
            <div class="input-group mb-3 firstInput">
              <span class="input-group-text" id="basic-addon1">
                <i class="fa-solid fa-layer-group"></i>
              </span>
              <input
                type="text"
                [(ngModel)]="subGroupName"
                class="form-control"
                name="sub-group-name"
                placeholder=""
                aria-label="Sub group name"
                aria-describedby="basic-addon1"
              />
            </div>
          </div>
          &NonBreakingSpace;
          <!-- Horizontal flex container for input + buttons -->
          <div class="input-button-row">
            <!-- Buttons -->
            <button
              (click)="cancelButton()"
              [ngClass]="theme.getThemeClass()"
              type="button"
              class="btn btn-secondary btnCancel"
            >
              {{ "cancel" | translate }}
            </button>
            <button
              (click)="createSubGroup()"
              [ngClass]="theme.getThemeClass()"
              type="button"
              class="btn btn-primary btnCreate"
              [disabled]="!subGroupName || subGroupName.trim() === ''"
            >
              {{ "create" | translate }}
            </button>
          </div>
        </div>

        <!-- Thing lsit -->
        <div class="thingsList">
          <table class="table table-hover">
            <!-- Table column header section -->
            <thead>
              <!-- Thing name -->
              <tr>
                <!-- Device header -->
                <th
                  [ngClass]="theme.getThemeClass()"
                  scope="col"
                  class="table-header-device"
                >
                  <a
                    [ngClass]="theme.getThemeClass()"
                    (click)="this.sortItems('thingName')"
                    href="javascript:void(0)"
                  >
                    {{ "iotTabHeaderDevice" | translate }}
                  </a>
                  <!-- IMG arrow up/down on sorting -->
                  @if (
                    this.sortDirection === 'asc' &&
                    this.sortBy === 'thingName'
                  ) {
                    <img
                      src="./assets/arrow-up.png"
                      width="10px"
                      height="10px"
                    />
                  } @if (
                    this.sortDirection === 'desc' &&
                    this.sortBy === 'thingName'
                  ) {
                    <img
                      src="./assets/arrow-down.png"
                      width="10px"
                      height="10px"
                    />
                  }
                </th>
                <!-- Device bin model -->
                <th [ngClass]="theme.getThemeClass()" class="hide-small-screen">
                  {{ "binModel" | translate }}
                </th>
                <!-- Bin Name -->
                <th [ngClass]="theme.getThemeClass()" class="hide-small-screen">
                  {{ "binHeader" | translate }}
                </th>
                <!-- fill level -->
                <th [ngClass]="theme.getThemeClass()" class="hide-small-screen">
                  {{ "filled" | translate }}
                </th>
                <!-- here for missing -->
                <!-- Volume of the bin/bin model associated to the device. Sort not implemented -->
                <th [ngClass]="theme.getThemeClass()" scope="col">
                  <a
                    [ngClass]="theme.getThemeClass()"
                    href="javascript:void(0)"
                  >
                    {{ "volume" | translate }}
                  </a>
                </th>

                <!-- Status of the bin associated to the device -->
                <th
                  [ngClass]="theme.getThemeClass()"
                  scope="col"
                  class="table-header-status"
                >
                  <a
                    [ngClass]="theme.getThemeClass()"
                    (click)="this.sortItems('status')"
                    href="javascript:void(0)"
                  >
                    {{ "iotTabHeaderStatus" | translate }}
                  </a>
                  <!-- IMG arrow up/down on sorting -->
                  @if (
                    this.sortDirection === 'asc' && this.sortBy === 'status'
                  ) {
                    <img
                      src="./assets/arrow-up.png"
                      width="10px"
                      height="10px"
                    />
                  } @if (
                    this.sortDirection === 'desc' && this.sortBy === 'status'
                  ) {
                    <img
                      src="./assets/arrow-down.png"
                      width="10px"
                      height="10px"
                    />
                  }
                </th>
                <!-- State of device. Sorted on last update date -->
                <th [ngClass]="theme.getThemeClass()" class="hide-small-screen">
                  <a
                    [ngClass]="theme.getThemeClass()"
                    (click)="this.sortItems('date')"
                    href="javascript:void(0)"
                  >
                    {{ "state" | translate }}
                  </a>
                  <!-- IMG arrow up/down on sorting -->
                  @if (this.sortDirection === 'asc' && this.sortBy === 'date') {
                    <img
                      src="./assets/arrow-up.png"
                      width="10px"
                      height="10px"
                    />
                  } @if (
                    this.sortDirection === 'desc' && this.sortBy === 'date'
                  ) {
                    <img
                      src="./assets/arrow-down.png"
                      width="10px"
                      height="10px"
                    />
                  }
                </th>
                <!-- Last activity of the device -->
                <th
                  [ngClass]="theme.getThemeClass()"
                  class="hide-small-screen table-header-last-activity"
                  scope="col"
                >
                  <a
                    [ngClass]="theme.getThemeClass()"
                    (click)="this.sortItems('date')"
                    href="javascript:void(0)"
                  >
                    {{ "iotTabHeaderLastActivity" | translate }}
                  </a>
                  <!-- IMG arrow up/down on sorting -->
                  @if (this.sortDirection === 'asc' && this.sortBy === 'date') {
                    <img
                      src="./assets/arrow-up.png"
                      width="10px"
                      height="10px"
                    />
                  } @if (
                    this.sortDirection === 'desc' && this.sortBy === 'date'
                  ) {
                    <img
                      src="./assets/arrow-down.png"
                      width="10px"
                      height="10px"
                    />
                  }
                </th>

                <!-- Ressources header for checkbox -->
                <th
                  [ngClass]="theme.getThemeClass()"
                  class="hide-small-screen table-header-ressources"
                  scope="col"
                >
                  {{ "selectDevice" | translate }}
                </th>
                <!-- emtpy th for check box column -->
                <th [ngClass]="theme.getThemeClass()"></th>
              </tr>
            </thead>
            <!-- Table content -->
            <tbody>
              <!-- Table populated with data from array (deviceArray) of devices in iotService -->
              @for (deviceRow of iotService.devicesArray; track deviceRow.thingName; let i = $index) {
                @if (deviceRow.bin?.client_id === client_id) {
                <tr
                  #minhadiv
                  class="rowTableData"
                >
                  <!-- Thing name or device name -->
                  <td
                    [ngClass]="theme.getThemeClass()"
                    (click)="
                      toggleDeviceDetails('mobile-' + deviceRow.thingName)
                    "
                  >
                    {{ deviceRow.thingName }}
                    <img
                      class="deviceInfoToggler show-small-screen"
                      [ngClass]="'mobile-' + deviceRow.thingName"
                      src="./assets/arrow-up.png"
                      width="10px"
                      height="10px"
                    />
                  </td>
                  <td
                    [ngClass]="theme.getThemeClass()"
                    class="hide-small-screen"
                  >
                    {{ deviceRow.bin?.bin_model_number ?? "N/A" }}
                  </td>
                  <td
                    [ngClass]="theme.getThemeClass()"
                    class="hide-small-screen"
                  >
                    {{ deviceRow.bin?.bin_name ?? "N/A" }}
                  </td>
                  <td
                    [ngClass]="theme.getThemeClass()"
                    class="hide-small-screen"
                  >
                    {{
                      calculateFillPercentage(
                        deviceRow.bin?.bin_height,
                        deviceRow.config?.dst
                      )
                    }}%
                  </td>
                  <!-- Volume of the bin associated -->
                  <td [ngClass]="theme.getThemeClass()">
                    {{
                      deviceRow.bin?.bin_height
                        ? deviceRow.bin?.total_volume
                        : "N/A"
                    }}
                  </td>

                  <!-- Status of the device -->
                  <td
                    [ngClass]="theme.getThemeClass()"
                    class="hide-small-screen"
                  >
                    <div
                      [ngClass]="{
                        healthy:
                          verifyStatus(deviceRow.thingName) === 'Healthy',
                        unhealthy:
                          verifyStatus(deviceRow.thingName) === 'Unhealthy',
                        inactive:
                          verifyStatus(deviceRow.thingName) === 'Inactive'
                      }"
                    >
                      {{ verifyStatus(deviceRow.thingName) | translate }}
                    </div>
                  </td>
                  <!-- State of the device -->
                  <td
                    [ngClass]="theme.getThemeClass()"
                    class="light-td"
                    (mouseover)="showStateInfo[i] = true"
                    (mouseleave)="showStateInfo[i] = false"
                  >
                    <div class="trafic-light-box">
                      <!-- Traffic light used for user to easily see if device have communicated for long time -->
                      <div class="traffic-light">
                        <div
                          class="light"
                          [ngClass]="{
                            'light-green':
                              deviceRow.heartbeat &&
                              deviceRow.heartbeat.color === 'green',
                            'light-yellow':
                              deviceRow.heartbeat &&
                              deviceRow.heartbeat.color === 'yellow',
                            'light-red':
                              deviceRow.heartbeat &&
                              deviceRow.heartbeat.color === 'red'
                          }"
                        ></div>
                      </div>
                      <!-- Info bubble on mouse over displaying number of beat miss, when he was suppose to comunicate and his sleep time config -->
                      @if (showStateInfo[i]) {
                        <div
                          class="info-state-box"
                          [ngClass]="theme.getThemeClass()"
                        >
                          <div class="state-info-layer">
                            <label class="state-title">
                              {{ "beatMiss" | translate }} :
                            </label>
                            <label class="state-info">
                              @if (
                                this.iotService.isBeatMissMoreThenOneHundred(
                                  deviceRow.heartbeat?.beat_miss
                                )
                              ) {<span>+</span>}
                              {{ deviceRow.heartbeat?.beat_miss || 0 }}
                            </label>
                          </div>
                          <div>
                            <label class="state-title">
                              {{ "suposeToCommunicate" | translate }} :
                            </label>
                            <label class="state-info">
                              {{ deviceRow.heartbeat?.supposed_to_communicate }}
                            </label>
                          </div>
                          <div>
                            <label class="state-title">
                              {{ "sleepTimeConfig" | translate }} :
                            </label>
                            <label class="state-info">
                              {{
                                this.iotService.convertSecondToHour(
                                  deviceRow.config?.slp
                                ) | translate
                              }}
                            </label>
                          </div>
                        </div>
                      }
                      <!-- End of the bubble -->
                    </div>
                  </td>
                  <!-- Last communication date/time -->
                  <td
                    class="hide-small-screen"
                    [ngClass]="theme.getThemeClass()"
                  >
                    <span class="link-shadow-feed">
                      {{ deviceRow.date }}
                    </span>
                  </td>
                  <!-- Ressources section displayed with little icons link -->
                  <td [ngClass]="theme.getThemeClass()" class="checkbox-cell">
                    <input
                      type="checkbox"
                      [id]="deviceRow.thingName"
                      [value]="deviceRow.thingName"
                      (change)="onCheckboxChange($event, deviceRow.thingName)"
                    />
                    <!-- Mobile extra row -->
                    <div
                      [ngClass]="theme.getThemeClass()"
                      class="deviceInfo hidden width100"
                      id="mobile-{{ deviceRow.thingName }}"
                    >
                      <h4 [ngClass]="theme.getThemeClass()" name="deviceName">
                        {{ deviceRow.thingName }}
                      </h4>

                      <div class="width100 binInfo">
                        <!-- binModel-->
                        <div [ngClass]="theme.getThemeClass()">
                          <label for="binModel">{{
                            "binModel" | translate
                          }}</label>
                          <p name="binModel">
                            {{ deviceRow.bin?.bin_model_number ?? "N/A" }}
                          </p>
                        </div>
                        <!-- bin_name -->
                        <div [ngClass]="theme.getThemeClass()">
                          <label for="bin_name">{{
                            "binHeader" | translate
                          }}</label>
                          <p name="bin_name">
                            {{ deviceRow.bin?.bin_name }}
                          </p>
                        </div>
                        <!-- filled-->
                        <div [ngClass]="theme.getThemeClass()">
                          <label for="filled">{{ "filled" | translate }}</label>
                          <p name="filled">
                            {{
                              calculateFillPercentage(
                                deviceRow.bin?.bin_height,
                                deviceRow.config?.dst
                              )
                            }}%
                          </p>
                        </div>
                        <!-- volume -->
                        <div [ngClass]="theme.getThemeClass()">
                          <label for="volume">
                            {{ "volume" | translate }}</label
                          >
                          <p name="volume">
                            {{
                              deviceRow.bin?.bin_height
                                ? deviceRow.bin?.total_volume
                                : "N/A"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                }
                <!-- Add the mobile banner here -->
              }
            </tbody>
          </table>
        </div>
      </form>
    </article>
    </section>
  }
  <!-- Sub-group list view -->
  @if (this.tab === 'view') {
    <section
      [ngClass]="theme.getThemeClass()"
      class="card"
    >
    <!-- Fitler by name input -->
    <div class="filter">
      <input
        type="search"
        id="search-box"
        aria-label="Search"
        aria-describedby="search-addon"
        class="form-control"
        name="subGroupFilter"
        [placeholder]="'subGroupCreateGroupName' | translate"
        [(ngModel)]="subGroupFilter"
        (input)="onSubGroupFilterChange()"
      />
      <button
        (click)="cancelButton()"
        [ngClass]="theme.getThemeClass()"
        type="button"
        class="btn btn-secondary btnCancel btn-block"
      >
        {{ "cancel" | translate }}
      </button>
      <button
        (click)="toCreateSubGroup()"
        [ngClass]="theme.getThemeClass()"
        type="button"
        class="btn btn-primary btn-block btnCreate"
      >
        {{ "createSubgroup" | translate }}
      </button>
    </div>
    <!-- Sub-group table -->
    <div class="sub-group-table-container">
      <table class="subgroup-table" [ngClass]="theme.getThemeClass()">
        <!-- Header with sort  -->
        <thead>
          <tr class="subgroup-header">
            <th style="padding: 4px" [ngClass]="theme.getThemeClass()">
              {{ "subGroups" | translate }}
              <!-- numerical sort  button -->
              <span
                (click)="changeOrder()"
                class="sort-icon"
                [ngClass]="{ rotated: !ascending }"
                style="cursor: pointer"
              >
                <i class="fa-solid fa-angle-up"></i>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Sub-group row -->
          @for (subGroup of clientSubGroups; track subGroup.sub_groupID) {
          <tr
            [ngClass]="theme.getThemeClass()"
          >
            <td>
              <!-- Sub-group name and number of device -->
              <div class="subgroup-header-1" [ngClass]="theme.getThemeClass()">
                {{ subGroup.sub_group_name }} ({{
                  subGroup.matchedDevices.length
                }})
                <!-- Add Device button -->
                <span
                  (click)="addDevice(subGroup.sub_groupID)"
                  style="cursor: pointer"
                >
                  <i class="fa-solid fa-plus"></i>
                </span>
                <!-- Extend sub-group toggler button -->
                <span
                  (click)="toggleSubGroup(subGroup.sub_groupID)"
                  class="sort-icon"
                  style="cursor: pointer"
                >
                  <i
                    class="fa-solid"
                    [ngClass]="{
                      'fa-angle-down': subGroup.expanded,
                      'fa-angle-up': !subGroup.expanded
                    }"
                  ></i>
                </span>
                <!-- Delete sub-group button -->
                <span
                  class="removeSubgroup"
                  (click)="openSubGroupDeleteModal(subGroup.sub_groupID)"
                  style="cursor: pointer"
                >
                  <i class="fa-solid fa-xmark" style="color: white;"></i>
                </span>
              </div>
              <!-- Sub-group device list section-->
              @if (subGroup.matchedDevices.length >= 0) {
                @if (subGroup.expanded) {
                <div class="device-scroll-container">
                  <table class="device-table">
                    <!-- Only one header per subgroup -->
                    <thead>
                      <tr [ngClass]="theme.getThemeClass()">
                        <th [ngClass]="theme.getThemeClass()">
                          {{ "iotTabHeaderDevice" | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()">
                          {{ "binModel" | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()">
                          {{ "binHeader" | translate }}
                        </th>
                        <th
                          class="hide-small-screen"
                          [ngClass]="theme.getThemeClass()"
                        >
                          {{ "filled" | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()">
                          {{ "volume" | translate }}
                        </th>
                        <th
                          class="hide-small-screen"
                          [ngClass]="theme.getThemeClass()"
                        >
                          {{ "iotTabHeaderStatus" | translate }}
                        </th>
                        <th
                          class="hide-small-screen"
                          [ngClass]="theme.getThemeClass()"
                        >
                          {{ "state" | translate }}
                        </th>
                        <th [ngClass]="theme.getThemeClass()">
                          {{ "iotTabHeaderLastActivity" | translate }}
                        </th>
                        <!-- Empty header for delete device button -->
                        <th [ngClass]="theme.getThemeClass()"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Sub-group device list-->
                      @for (deviceRow of subGroup.matchedDevices; track deviceRow.thingName) {
                        <tr>
                          <!-- Device  name -->
                          <td
                            (click)="toggleDeviceDetails(deviceRow.thingName)"
                          >
                            {{ deviceRow.thingName }}
                            <img
                              class="deviceInfoToggler show-small-screen"
                              [ngClass]="deviceRow.thingName"
                              src="./assets/arrow-up.png"
                              width="10px"
                              height="10px"
                            />
                          </td>
                          <!-- Device  bin model -->
                          <td>
                            {{ deviceRow.bin?.bin_model_number ?? "N/A" }}
                          </td>
                          <td>{{ deviceRow.bin?.bin_name ?? "N/A" }}</td>
                          <td class="hide-small-screen">
                            {{
                              calculateFillPercentage(
                                deviceRow.bin?.bin_height,
                                deviceRow.config.dst
                              )
                            }}%
                          </td>
                          <!-- Device  bin height -->
                          <td>
                            {{
                              deviceRow.bin?.bin_height
                                ? deviceRow.bin?.total_volume
                                : "N/A"
                            }}
                          </td>
                          <!-- Device  Status -->
                          <td class="status hide-small-screen">
                            <span
                              class="status-label"
                              [ngClass]="{
                                healthy:
                                  verifyStatus(deviceRow.thingName) ===
                                  'Healthy',
                                unhealthy:
                                  verifyStatus(deviceRow.thingName) ===
                                  'Unhealthy',
                                inactive:
                                  verifyStatus(deviceRow.thingName) ===
                                  'Inactive'
                              }"
                            >
                              {{
                                verifyStatus(deviceRow.thingName) | translate
                              }}
                            </span>
                          </td>
                          <!-- Device  beat missed -->
                          <td class="hide-small-screen">
                            <div class="traffic-light traffic-light-style">
                              <div
                                class="light"
                                [ngClass]="{
                                  'light-green':
                                    deviceRow.heartbeat?.color === 'green',
                                  'light-yellow':
                                    deviceRow.heartbeat?.color === 'yellow',
                                  'light-red':
                                    deviceRow.heartbeat?.color === 'red'
                                }"
                              ></div>
                            </div>
                          </td>
                          <!-- Device  shadow feed -->
                          <td>
                            <a>
                              {{ deviceRow.date }}
                            </a>
                          </td>
                          <!-- Delete device button -->
                          <td>
                            <span
                              class="removeDevice"
                              (click)="
                                removeDevice(
                                  deviceRow.thingName,
                                  subGroup.sub_groupID
                                )
                              "
                            >
                              <i
                                class="fa-solid fa-xmark"
                                style="color: red"
                              ></i>
                            </span>
                            <!-- Mobile extra row -->
                            <div
                              [ngClass]="theme.getThemeClass()"
                              class="deviceInfo hidden width100"
                              id="{{ deviceRow.thingName }}"
                            >
                              <h4
                                [ngClass]="theme.getThemeClass()"
                                name="deviceName"
                              >
                                {{ deviceRow.thingName }}
                              </h4>

                              <div class="width100 binInfo">
                                <!-- binModel-->
                                <div [ngClass]="theme.getThemeClass()">
                                  <label for="binModel">{{
                                    "binModel" | translate
                                  }}</label>
                                  <p name="binModel">
                                    {{
                                      deviceRow.bin?.bin_model_number ?? "N/A"
                                    }}
                                  </p>
                                </div>
                                <!-- bin_name -->
                                <div [ngClass]="theme.getThemeClass()">
                                  <label for="bin_name">{{
                                    "binHeader" | translate
                                  }}</label>
                                  <p name="bin_name">
                                    {{ deviceRow.bin?.bin_name }}
                                  </p>
                                </div>
                                <!-- filled-->
                                <div [ngClass]="theme.getThemeClass()">
                                  <label for="filled">{{
                                    "filled" | translate
                                  }}</label>
                                  <p name="filled">
                                    {{
                                      calculateFillPercentage(
                                        deviceRow.bin?.bin_height,
                                        deviceRow.config.dst
                                      )
                                    }}%
                                  </p>
                                </div>
                                <!-- volume -->
                                <div [ngClass]="theme.getThemeClass()">
                                  <label for="volume">
                                    {{ "volume" | translate }}</label
                                  >
                                  <p name="volume">
                                    {{
                                      deviceRow.bin?.bin_height
                                        ? deviceRow.bin?.total_volume
                                        : "N/A"
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                }
              }
              <!-- no device UI template -->
              @if (subGroup.matchedDevices.length === 0) {
                <div
                  class="no-devices"
                >
                  {{ "noDevicesFound" | translate }}
                </div>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    </section>
  }
</div>
<!-- Add / remove device modal -->
@if (this.AddRemoveDeviceOpen) {
<div
  [ngClass]="theme.getThemeClass()"
  class="AddRemoveDevice"
>
  <!-- Device name filter -->
  <div class="filter-add-device" [ngClass]="theme.getThemeClass()">
    <div style="width: 50%">
      <label class="form-label" for="AddDeviceTosubGroupFilter"
        >{{ "selectDevices" | translate }}
      </label>
      <input
        type="search"
        id="sub-group-search-box"
        aria-label="Search"
        aria-describedby="search-addon"
        class="form-control"
        name="AddDeviceTosubGroupFilter"
        placeholder="{{ 'iotModalViewDeviceName' | translate }}"
        [(ngModel)]="AddDeviceTosubGroupFilter"
        (input)="OnAddDeviceTosubGroupFilterChange()"
      />
    </div>
    <!-- Add device(s) button -->
    <button
      (click)="addToSubGroup()"
      [ngClass]="theme.getThemeClass()"
      type="button"
      class="btn btn-primary btn-block btnCreate fixed-size addSG"
      [disabled]="!selectedDevices || selectedDevices.length === 0"
    >
      {{ "subGroupAddDevice" | translate }}
    </button>
    <!-- Close modal button -->
    <div class="closeBTN">
      <span (click)="closeModal()"><i class="fa-solid fa-xmark"></i></span>
    </div>
  </div>
  <table class="table table-hover">
    <!-- Deviceable column header -->
    <thead class="AddtableHeader">
      <tr>
        <!-- Thing name -->
        <th
          [ngClass]="theme.getThemeClass()"
          scope="col"
          class="table-header-device"
        >
          <a [ngClass]="theme.getThemeClass()">
            {{ "iotTabHeaderDevice" | translate }}
          </a>
        </th>
        <!-- Device bin model -->
        <th [ngClass]="theme.getThemeClass()">{{ "binModel" | translate }}</th>
        <!-- Bin Name -->
        <th [ngClass]="theme.getThemeClass()">{{ "binHeader" | translate }}</th>
        <!-- fill level -->
        <th [ngClass]="theme.getThemeClass()" class="hide-small-screen">
          {{ "filled" | translate }}
        </th>

        <!-- Volume of the bin/bin model associated to the device. Sort not implemented -->
        <th
          [ngClass]="theme.getThemeClass()"
          class="hide-small-screen"
          scope="col"
        >
          <a [ngClass]="theme.getThemeClass()" href="javascript:void(0)">
            {{ "volume" | translate }}
          </a>
        </th>

        <!-- Status of the bin associated to the device -->
        <th
          [ngClass]="theme.getThemeClass()"
          scope="col"
          class="table-header-status hide-small-screen"
        >
          <a
            [ngClass]="theme.getThemeClass()"
            (click)="this.sortItems('status')"
            href="javascript:void(0)"
          >
            {{ "iotTabHeaderStatus" | translate }}
          </a>
        </th>
        <!-- State of device. Sorted on last update date -->
        <th [ngClass]="theme.getThemeClass()" class="hide-small-screen">
          <a
            [ngClass]="theme.getThemeClass()"
            (click)="this.sortItems('date')"
            href="javascript:void(0)"
          >
            {{ "state" | translate }}
          </a>
        </th>
        <!-- Last activity of the device -->
        <th
          [ngClass]="theme.getThemeClass()"
          class="hide-small-screen table-header-last-activity"
          scope="col"
        >
          <a
            [ngClass]="theme.getThemeClass()"
            (click)="this.sortItems('date')"
            href="javascript:void(0)"
          >
            {{ "iotTabHeaderLastActivity" | translate }}
          </a>
        </th>

        <!-- Select device checkbox -->
        <th
          [ngClass]="theme.getThemeClass()"
          class="hide-small-screen table-header-ressources"
          scope="col"
        >
          {{ "selectDeviceSubGroupModal" | translate }}
        </th>
        <th [ngClass]="theme.getThemeClass()"></th>
      </tr>
    </thead>
    <!-- Table content -->
    <tbody>
      <!-- Table populated with data from array (deviceArray) of devices in iotService -->
      @for (deviceRow of availableDevices; track deviceRow.thingName; let i = $index) {
        <!-- .devicesArray.slice(
            0,
            loadedItems + itemsPerPage
          ) -->
        @if (deviceRow.bin?.client_id === client_id) {
        <tr
          #minhadiv
          class="rowTableData"
        >
          <!-- device name -->
          <td
            [ngClass]="theme.getThemeClass()"
            (click)="toggleDeviceDetails('mobile-' + deviceRow.thingName)"
          >
            {{ deviceRow.thingName }}
            <img
              class="deviceInfoToggler show-small-screen"
              [ngClass]="'mobile-' + deviceRow.thingName"
              src="./assets/arrow-up.png"
              width="10px"
              height="10px"
            />
          </td>
          <!-- Device bin model -->
          <td [ngClass]="theme.getThemeClass()">
            {{ deviceRow.bin?.bin_model_number ?? "N/A" }}
          </td>
          <!-- Device bin name -->
          <td [ngClass]="theme.getThemeClass()">
            {{ deviceRow.bin?.bin_name ?? "N/A" }}
          </td>
          <!-- Fil level -->
          <td [ngClass]="theme.getThemeClass()" class="hide-small-screen">
            {{
              calculateFillPercentage(
                deviceRow.bin?.bin_height,
                deviceRow.config.dst
              )
            }}%
          </td>
          <!-- Device bin height -->
          <td [ngClass]="theme.getThemeClass()" class="hide-small-screen">
            {{
              deviceRow.bin?.bin_height ? deviceRow.bin?.total_volume : "N/A"
            }}
          </td>

          <!-- Status of the device -->
          <td [ngClass]="theme.getThemeClass()" class="hide-small-screen">
            <div
              [ngClass]="{
                healthy: verifyStatus(deviceRow.thingName) === 'Healthy',
                unhealthy: verifyStatus(deviceRow.thingName) === 'Unhealthy',
                inactive: verifyStatus(deviceRow.thingName) === 'Inactive'
              }"
            >
              {{ verifyStatus(deviceRow.thingName) | translate }}
            </div>
          </td>
          <!-- State of the device -->
          <td
            [ngClass]="theme.getThemeClass()"
            class="light-td hide-small-screen"
            (mouseover)="showStateInfo[i] = true"
            (mouseleave)="showStateInfo[i] = false"
          >
            <div class="trafic-light-box">
              <!-- Traffic light used for user to easily see if device have communicated for long time -->
              <div class="traffic-light">
                <div
                  class="light"
                  [ngClass]="{
                    'light-green':
                      deviceRow.heartbeat &&
                      deviceRow.heartbeat.color === 'green',
                    'light-yellow':
                      deviceRow.heartbeat &&
                      deviceRow.heartbeat.color === 'yellow',
                    'light-red':
                      deviceRow.heartbeat && deviceRow.heartbeat.color === 'red'
                  }"
                ></div>
              </div>
              <!-- Info bubble on mouse over displaying number of beat miss, when he was suppose to comunicate and his sleep time config -->
              @if (showStateInfo[i]) {
                <div
                  class="info-state-box"
                  [ngClass]="theme.getThemeClass()"
                >
                  <div class="state-info-layer">
                    <label class="state-title">
                      {{ "beatMiss" | translate }} :
                    </label>
                    <label class="state-info">
                      @if (
                        this.iotService.isBeatMissMoreThenOneHundred(
                          deviceRow.heartbeat?.beat_miss
                        )
                      ) {<span>+</span>}
                      {{ deviceRow.heartbeat?.beat_miss || 0 }}
                    </label>
                  </div>
                  <div>
                    <label class="state-title">
                      {{ "suposeToCommunicate" | translate }} :
                    </label>
                    <label class="state-info">
                      {{ deviceRow.heartbeat?.supposed_to_communicate }}
                    </label>
                  </div>
                  <div>
                    <label class="state-title">
                      {{ "sleepTimeConfig" | translate }} :
                    </label>
                    <label class="state-info">
                      {{
                        this.iotService.convertSecondToHour(deviceRow.config?.slp)
                          | translate
                      }}
                    </label>
                  </div>
                </div>
              }
              <!-- End of the bubble -->
            </div>
          </td>
          <!-- Last communication date/time -->
          <td class="hide-small-screen" [ngClass]="theme.getThemeClass()">
            <span class="link-shadow-feed">
              {{ deviceRow.date }}
            </span>
          </td>
          <!-- Select device checkbox -->
          <td [ngClass]="theme.getThemeClass()" class="checkbox-cell">
            <input
              type="checkbox"
              [id]="deviceRow.thingName"
              [value]="deviceRow.thingName"
              [checked]="selectedDevices.includes(deviceRow.thingName)"
              (change)="onCheckboxChange($event, deviceRow.thingName)"
            />
            <!-- Mobile extra row -->
            <div
              [ngClass]="theme.getThemeClass()"
              class="deviceInfo hidden width100"
              id="mobile-{{ deviceRow.thingName }}"
            >
              <h4 [ngClass]="theme.getThemeClass()" name="deviceName">
                {{ deviceRow.thingName }}
              </h4>

              <div class="width100 binInfo">
                <!-- binModel-->
                <div [ngClass]="theme.getThemeClass()">
                  <label for="binModel">{{ "binModel" | translate }}</label>
                  <p name="binModel">
                    {{ deviceRow.bin?.bin_model_number ?? "N/A" }}
                  </p>
                </div>
                <!-- bin_name -->
                <div [ngClass]="theme.getThemeClass()">
                  <label for="bin_name">{{ "binHeader" | translate }}</label>
                  <p name="bin_name">
                    {{ deviceRow.bin?.bin_name }}
                  </p>
                </div>
                <!-- filled-->
                <div [ngClass]="theme.getThemeClass()">
                  <label for="filled">{{ "filled" | translate }}</label>
                  <p name="filled">
                    {{
                      calculateFillPercentage(
                        deviceRow.bin?.bin_height,
                        deviceRow.config.dst
                      )
                    }}%
                  </p>
                </div>
                <!-- volume -->
                <div [ngClass]="theme.getThemeClass()">
                  <label for="volume"> {{ "volume" | translate }}</label>
                  <p name="volume">
                    {{
                      deviceRow.bin?.bin_height
                        ? deviceRow.bin?.total_volume
                        : "N/A"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </td>
        </tr>
        }
      }
    </tbody>
  </table>
</div>
}
<!-- Delete sub-group modal -->
@if (deviceDeletion) {
<div
  [ngClass]="theme.getThemeClass()"
  class="subGroupDeleteModal"
>
  <!-- Close button -->
  <div class="closeBTN">
    <span (click)="closeSubGroupDeleteModal()"
      ><i class="fa-solid fa-xmark"></i
    ></span>
  </div>
  <!-- Modal title -->
  <h2 style="text-align: center; font-size: 18px">
    {{ "deleteSubGroupModal" | translate }}
    {{ this.subGroupToDelete.sub_group_name }}
  </h2>
  <!-- Global Transfer Dropdown -->
  <!-- used to asigne all selected devices to specific subgroup -->
  <div class="global-transfer">
    <!-- Label -->
    <label for="globalTarget">{{
      "transferSelectedDevicesTo" | translate
    }}</label>
    <!-- target sub-group select -->
    <div class="globalTargetSelect">
      <select [(ngModel)]="selectedGlobalSubgroupId" class="form-select">
        @for (group of clientSubGroups; track group.sub_groupID) {
          <option
            [value]="group.sub_groupID"
            [disabled]="group.sub_groupID === currentSubGroupId"
          >
            {{ group.sub_group_name }}
          </option>
        }
      </select>
      <!-- Assign button -->
      <button (click)="assignAllDevicesToSelectedGroup()" class="btn">
        {{ "setSelected" | translate }}
      </button>
    </div>
  </div>
  @if (devicesInCurrentSubGroup.length) {
  <table class="device-transfer-table">
    <thead>
      <tr>
        <th [ngClass]="theme.getThemeClass()" class="col-name">{{ "iotTabHeaderDevice" | translate }}</th>
        <th [ngClass]="theme.getThemeClass()" class="col-select-target">{{ "selectSubGroup" | translate }}</th>
        <th [ngClass]="theme.getThemeClass()" class="col-select">
          @if (devicesInCurrentSubGroup.length > 1) {
            <div
              class="select-all-cell"
            >
              <input
                type="checkbox"
                [(ngModel)]="selectAll"
                (change)="onSelectAllChange()"
                class="form-check-input"
                style="height: 16px; width: 16px;"
              />
              <label class="select-all-label">{{
                "selectALl" | translate
              }}</label>
            </div>
          }
        </th>
      </tr>
    </thead>

    <tbody>
      @for (device of devicesInCurrentSubGroup; track device.thingName) {
      <tr
        class="device-transfer-row"
      >
        <!-- Device name -->
        <td class="col-name">
          <span class="device-name" [title]="device.thingName">{{
            device.thingName
          }}</span>
        </td>

        <!-- Dropdown for subgroup transfer -->
        <td class="col-select-target">
          <select
            [(ngModel)]="deviceTransferMap[device.thingName]"
            [disabled]="!deviceSelectionMap[device.thingName]"
            class="form-select"
          >
            <option value="" selected>
              {{ "selectSubGroup" | translate }}
            </option>
            @for (group of clientSubGroups; track group.sub_groupID) {
              <option
                [value]="group.sub_groupID"
                [disabled]="group.sub_groupID === currentSubGroupId"
              >
                {{ group.sub_group_name }}
              </option>
            }
          </select>
        </td>

        <!-- Checkbox to select device -->
        <td class="col-select">
          <input
            type="checkbox"
            [(ngModel)]="deviceSelectionMap[device.thingName]"
            (change)="onDeviceSelectChange(device.thingName)"
            class="form-check-input"
            [attr.aria-label]="device.thingName"
          />
        </td>
      </tr>
      }
    </tbody>
  </table>
  }

  <!-- Confirm Delete & Transfer Button -->
  <div class="modal-actions">
    <!-- Delete subroup & Reassigne devices button -->
    <button
      (click)="confirmSubGroupDeletion(2)"
      class="btn"
      [disabled]="isReassignDeleteDisabled()"
    >
      {{ "confirmDeletReasign" | translate }}
    </button>
    <!-- Delete subroup -->
    <button (click)="confirmSubGroupDeletion(1)" class="btn">
      {{ "confirmDeletion" | translate }}
    </button>
  </div>
</div>
}
